// extracted by mini-css-extract-plugin
export default {"dropdownContainer":"CustomLoginButton__dropdownContainer___AKLyN","skeleton-loading":"CustomLoginButton__skeleton-loading___cSwmj"};